import {call, put} from 'redux-saga/effects';
import CarsActions from '../redux/CarsRedux';
import MessagesActions from '../redux/MessagesRedux';
import { preparePhoneNumber } from '../helpers/string';

export function * checkCar(api, action) {
  const {vin, epts} = action;
  const response = yield call(api.checkCar, vin, epts);

  if (response.ok) {
    yield put(CarsActions.carCheckSuccess(response.data));
  } else {
    yield put(CarsActions.carFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}

export function * addCar(api, action) {
  const response = yield call(api.addCar, action.id, {...action.data});

  if (response.ok) {
    yield put(CarsActions.carSuccess(response.data));
    yield put(MessagesActions.messagesShow({type: 'success', code: 'carsAdd', title: 'Запись успешно создана'}));
  } else {
    yield put(CarsActions.carFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}

export function * updateCar(api, action) {
  let data = {...action.data};
  // формируем корректный номер телефона
  if (data.agents) {
    data.agents = data.agents.map(agent => ({...agent, phone: preparePhoneNumber(agent.phone)}));
  }

  const response = yield call(api.editCar, data);

  if (response.ok) {
    yield put(CarsActions.carSuccess(response.data));
    yield put(MessagesActions.messagesShow({type: 'success', code: 'carsUpdate', title: 'Запись успешно обновлена'}));
  } else {
    yield put(CarsActions.carFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}

export function * deleteCar(api, action) {
  const response = yield call(api.deleteCars, action.id);

  if (response.ok) {
    yield put(CarsActions.carSuccess(null));
    yield put(MessagesActions.messagesShow({type: 'success', code: 'carsDelete', title: 'Запись успешно удалена'}));
  } else {
    yield put(CarsActions.carFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}
